const PubDevIcon = (props: any) => (
  <svg xmlSpace="preserve" viewBox="0 0 139 139" {...props}>
    <path
      fill="#01579B"
      d="M29.64 108.94 6.36 85.66c-2.76-2.84-4.48-6.84-4.48-10.75 0-1.81 1.02-4.64 1.79-6.27l21.49-44.77 4.48 85.07z"
    />
    <path
      fill="#40C4FF"
      d="M109.34 28.35 86.06 5.07C84.03 3.03 79.79.59 76.21.59c-3.08 0-6.1.62-8.06 1.79L25.17 23.87l84.17 4.48zM57.4 136.7h56.42v-24.18L71.73 99.09l-38.5 13.43z"
    />
    <path
      fill="#29B6F6"
      d="M25.17 96.41c0 7.18.9 8.95 4.48 12.54l3.58 3.58h80.59l-39.4-44.77-49.25-43.88v72.53z"
    />
    <path
      fill="#01579B"
      d="M96.8 23.87H25.16l88.65 88.65h24.18V57l-28.65-28.65c-4.02-4.04-7.6-4.48-12.54-4.48z"
    />
    <path
      fill="#FFF"
      d="M30.54 109.84c-3.58-3.6-4.48-7.14-4.48-13.43V24.77l-.9-.9V96.4c.01 6.3.01 8.04 5.38 13.44l2.69 2.69-2.69-2.69z"
      opacity={0.2}
    />
    <path
      fill="#263238"
      d="M137.1 56.11v55.52h-24.18l.9.89H138V57.01z"
      opacity={0.2}
    />
    <path
      fill="#FFF"
      d="M109.34 28.35c-4.44-4.44-8.08-4.48-13.43-4.48H25.17l.9.9h69.85c2.66 0 9.41-.45 13.42 3.58z"
      opacity={0.2}
    />
    <radialGradient
      id="a"
      cx={69.955}
      cy={60.886}
      r={68.065}
      gradientTransform="matrix(1 0 0 -1 0 129.533)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#fff",
          stopOpacity: 0.1,
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#fff",
          stopOpacity: 0,
        }}
      />
    </radialGradient>
    <path
      fill="url(#a)"
      d="m137.1 56.11-27.76-27.76L86.06 5.07C84.03 3.03 79.79.59 76.21.59c-3.08 0-6.1.62-8.06 1.79L25.17 23.87 3.68 68.64c-.77 1.63-1.79 4.46-1.79 6.27 0 3.91 1.72 7.91 4.48 10.75l21.46 21.3c.51.63 1.11 1.27 1.83 1.98l.9.9 2.69 2.69 23.28 23.28.9.9h56.42v-24.18h24.18V57.01l-.93-.9z"
      opacity={0.2}
    />
  </svg>
);

export default PubDevIcon;
